import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["onClick"]

import { withDefaults } from "vue";
import { Icon, NavigateNextIcon } from "@/components/Icons";
interface TabsMenuProps {
  data?: string[];
  activeIndex?: number;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TabsMenu',
  props: {
    data: { default: () => [] },
    activeIndex: { default: 0 }
  },
  emits: ["click"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style.wrap)
  }, [
    (__props.data.length > 0)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(_ctx.$style.bar),
          style: _normalizeStyle(`transform: translateY(${100 * __props.activeIndex}%);`)
        }, null, 6))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass([_ctx.$style.item, { active: __props.activeIndex === index }]),
        key: index,
        onClick: ($event: any) => (_ctx.$emit('click', index))
      }, [
        _createElementVNode("span", null, _toDisplayString(item), 1),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.$style['icon-wrap'])
        }, [
          _createVNode(_unref(Icon), { size: 24 }, {
            default: _withCtx(() => [
              _createVNode(_unref(NavigateNextIcon))
            ]),
            _: 1
          })
        ], 2)
      ], 10, _hoisted_1))
    }), 128))
  ], 2))
}
}

})